// Cut polylines at a circular eraser's boundary, preserving the un-erased portions.
export function eraseCircle(points, centre, radius = 14) {
    const result = []; let run = [];
    const flush = () => { if (run.length > 1) result.push(run); run = []; };
    for (let i = 1; i < points.length; i++) {
        const a = points[i - 1], b = points[i], dx = b[0] - a[0], dy = b[1] - a[1];
        const x = a[0] - centre[0], y = a[1] - centre[1], aa = dx * dx + dy * dy;
        if (!aa) continue;
        const bb = 2 * (x * dx + y * dy), cc = x * x + y * y - radius * radius;
        const disc = bb * bb - 4 * aa * cc;
        const cuts = [0, 1];
        if (disc > 0) for (const t of [(-bb - Math.sqrt(disc)) / (2 * aa), (-bb + Math.sqrt(disc)) / (2 * aa)]) if (t > 0 && t < 1) cuts.push(t);
        cuts.sort((u, v) => u - v);
        const at = t => [a[0] + dx * t, a[1] + dy * t];
        for (let j = 1; j < cuts.length; j++) {
            const mid = at((cuts[j - 1] + cuts[j]) / 2);
            if (Math.hypot(mid[0] - centre[0], mid[1] - centre[1]) < radius) flush();
            else { if (!run.length) run.push(at(cuts[j - 1])); run.push(at(cuts[j])); }
        }
    }
    flush(); return result;
}

export function eraseSweep(points, from, to, radius = 14) {
    let fragments = [points];
    const count = Math.max(1, Math.ceil(Math.hypot(to[0] - from[0], to[1] - from[1]) / (radius / 2)));
    for (let i = 0; i <= count; i++) {
        const centre = [from[0] + (to[0] - from[0]) * i / count, from[1] + (to[1] - from[1]) * i / count];
        fragments = fragments.flatMap(p => eraseCircle(p, centre, radius));
    }
    return fragments;
}
